const table = {
    headSize: {
        'M': {
            'circumference': [51, 59]
        }, "L": {
            'circumference': [60, 64]
        }
    }, canineBodySize: {
        'S': {
            'neck': [36, 43], 'chest': [56, 64], 'back_length': [36, 38],
        }, 'M': {
            'neck': [46, 53], 'chest': [66, 76], 'back_length': [41, 43],
        }, 'L': {
            'neck': [56, 64], 'chest': [79, 86], 'back_length': [46, 48],
        }, 'XL': {
            'neck': [66, 74], 'chest': [89, 99], 'back_length': [51, 53],
        },
    }, laptopSize: {
        'S': {
            'length': [36, 43], 'width': [56, 64], 'thickness': [36, 38],
        }, 'M': {
            'length': [46, 53], 'width': [66, 76], 'thickness': [41, 43],
        }, 'L': {
            'length': [56, 64], 'width': [79, 86], 'thickness': [46, 48],
        },

    }, beltSize: {
        'S/M': {
            'chest': [84, 110], 'waist': [72, 98]
        }, "L/XL": {
            'chest': [111, 134], 'waist': [99, 122]
        }
    }, bodySize: {
        'S': {
            'chest': [84, 94], 'waist': [72, 82]
        }, 'M': {
            'chest': [95, 110], 'waist': [83, 98]
        }, "L": {
            'chest': [111, 118], 'waist': [99, 106]
        }, "XL": {
            'chest': [119, 134], 'waist': [107, 122]
        }, 'set': ['bodySizeVest', 'bodySizeCummerband']
    }, bodySizeWithoutCummerband: {
        'S': {
            'chest': [84, 94], 'waist': [72, 82]
        }, 'M': {
            'chest': [95, 110], 'waist': [83, 98]
        }, "L": {
            'chest': [111, 118], 'waist': [99, 106]
        }, "XL": {
            'chest': [119, 134], 'waist': [107, 122]
        },
    }, bodySizeVest: {
        'S1': {
            'chest': [84, 94], 'waist': [72, 82]
        }, 'M1': {
            'chest': [95, 110], 'waist': [72, 98]
        }, 'M2': {
            'chest': [84, 94], 'waist': [83, 98]
        }, "L1": {
            'chest': [84, 118], 'waist': [99, 106]
        }, "L2": {
            'chest': [111, 118], 'waist': [72, 98]
        }, "XL1": {
            'chest': [84, 119], 'waist': [107, 122]
        }, "XL2": {
            'chest': [119, 134], 'waist': [72, 106]
        },
    },
    panelSize: {
        'S1': {
            'chest': [84, 94], 'waist': [72, 82]
        }, 'M1': {
            'chest': [95, 110], 'waist': [72, 82]
        }, 'M2': {
            'chest': [84, 110], 'waist': [83, 98]
        }, "L1": {
            'chest': [84, 118], 'waist': [99, 106]
        }, "L2": {
            'chest': [111, 118], 'waist': [72, 98]
        }, "XL1": {
            'chest': [84, 134], 'waist': [107, 122]
        }, "XL2": {
            'chest': [119, 134], 'waist': [72, 106]
        },
    },


    bodySizeCummerband: {
        'S1': {
            'chest': [84, 110], 'waist': [72, 82]
        }, 'M1': {
            'chest': [111, 118], 'waist': [72, 82]
        }, 'M2': {
            'chest': [84, 94], 'waist': [83, 98]
        }, 'M3': {
            'chest': [95, 110], 'waist': [83, 98]
        }, 'M4': {
            'chest': [111, 118], 'waist': [83, 98]
        }, 'M5': {
            'chest': [84, 94], 'waist': [99, 106]
        }, 'L1': {
            'chest': [119, 134], 'waist': [72, 82]
        }, 'L2': {
            'chest': [119, 134], 'waist': [83, 98]
        }, 'L3': {
            'chest': [95, 110], 'waist': [99, 106]
        }, 'L4': {
            'chest': [111, 118], 'waist': [99, 106]
        }, 'L5': {
            'chest': [119, 134], 'waist': [99, 106]
        }, 'L6': {
            'chest': [84, 94], 'waist': [107, 122]
        }, 'L7': {
            'chest': [95, 110], 'waist': [107, 122]
        }, "XL1": {
            'chest': [111, 118], 'waist': [107, 122]
        }, "XL2": {
            'chest': [119, 134], 'waist': [107, 122]
        }
    }, vestBodySize: {
        'S': {

            'chest': [84, 94], 'waist': [72, 82],
        }, 'M': {

            'chest': [95, 102], 'waist': [83, 90],
        }, 'L': {

            'chest': [103, 110], 'waist': [91, 98],
        }, 'XL': {

            'chest': [111, 118], 'waist': [99, 106],
        }, '2XL': {

            'chest': [119, 127], 'waist': [107, 114],
        }, '3XL': {

            'chest': [128, 134], 'waist': [115, 122],
        },

    }, vestBodySizeVest: {
        'S1': {
            'chest': [84, 94], 'waist': [72, 122],
        }, 'M1': {
            'chest': [95, 102], 'waist': [72, 122],
        }, 'L1': {
            'chest': [113, 110], 'waist': [72, 122],
        }, 'XL1': {
            'chest': [111, 118], 'waist': [72, 122],
        }, '2XL1': {
            'chest': [119, 127], 'waist': [72, 122],
        }, '3XL1': {
            'chest': [128, 134], 'waist': [72, 122],
        },


    }, femaleVestBodySizeVest: {
        'S1': {
            'chest': [75, 82], 'waist': [58, 94],
        }, 'M1': {
            'chest': [83, 90], 'waist': [58, 94],
        }, 'L1': {
            'chest': [91, 98], 'waist': [58, 94],
        }, 'XL1': {
            'chest': [99, 106], 'waist': [58, 94],
        }, '2XL1': {
            'chest': [107, 114], 'waist': [58, 94],
        },
    }, vestBodySizeCummerband: {
        'S1': {
            'chest': [84, 94], 'waist': [72, 82],
        }, 'S2': {
            'chest': [95, 102], 'waist': [72, 82],
        }, 'M1': {
            'chest': [113, 110], 'waist': [72, 82],
        }, 'M2': {
            'chest': [84, 110], 'waist': [83, 90],
        }, 'L1': {
            'chest': [111, 118], 'waist': [72, 90],
        }, 'L2': {
            'chest': [84, 118], 'waist': [91, 98],
        }, 'L3': {
            'chest': [95, 110], 'waist': [99, 106],
        },

        'XL1': {
            'chest': [119, 127], 'waist': [72, 106],
        }, 'XL2': {
            'chest': [111, 118], 'waist': [99, 106],
        }, 'XL3': {
            'chest': [95, 110], 'waist': [107, 114],
        }, 'XL4': {
            'chest': [84, 94], 'waist': [99, 106],
        }, '2XL1': {
            'chest': [128, 134], 'waist': [72, 114],
        }, '2XL2': {
            'chest': [111, 127], 'waist': [107, 114],
        }, '2XL3': {
            'chest': [95, 110], 'waist': [115, 122],
        }, '2XL4': {
            'chest': [84, 94], 'waist': [107, 114],
        }, '3XL1': {
            'chest': [111, 134], 'waist': [115, 122],
        }, '3XL2': {
            'chest': [84, 94], 'waist': [115, 122],
        },


    }, femaleVestBodySizeCummerband: {
        'S1': {
            'chest': [75, 114], 'waist': [58, 64],
        }, 'M1': {
            'chest': [75, 114], 'waist': [65, 71],
        }, 'L1': {
            'chest': [75, 114], 'waist': [72, 78],
        }, 'XL1': {
            'chest': [75, 114], 'waist': [79, 85],
        }, '2XL1': {
            'chest': [75, 114], 'waist': [86, 94],
        },
    }, vestBodySizeWithoutCummerband: {
        'S': {
            'height': [158, 164], 'chest': [84, 94], 'waist': [72, 82],
        }, 'M': {
            'height': [165, 170], 'chest': [95, 102], 'waist': [83, 90],
        }, 'L': {
            'height': [171, 176], 'chest': [103, 110], 'waist': [91, 98],
        }, 'XL': {
            'height': [177, 182], 'chest': [111, 118], 'waist': [99, 106],
        }, '2XL': {
            'height': [183, 188], 'chest': [119, 127], 'waist': [107, 114],
        }, '3XL': {
            'height': [189, 194], 'chest': [128, 134], 'waist': [115, 122],
        },

    }, femaleVestBodySize: {
        'S': {

            'chest': [75, 82], 'waist': [58, 64],
        }, 'M': {

            'chest': [83, 90], 'waist': [65, 71],
        }, 'L': {

            'chest': [91, 98], 'waist': [72, 79],
        }, 'XL': {

            'chest': [99, 106], 'waist': [79, 85],
        }, '2XL': {

            'chest': [107, 114], 'waist': [86, 94],
        }, 'set': ['femaleVestBodySizeVest', 'femaleVestBodySizeCummerband']

    }, femaleVestBodySizeWithoutCummerband: {
        'S': {
            'height': [146, 152], 'chest': [75, 82], 'waist': [58, 64],
        }, 'M': {
            'height': [153, 158], 'chest': [83, 90], 'waist': [65, 71],
        }, 'L': {
            'height': [159, 164], 'chest': [91, 98], 'waist': [72, 79],
        }, 'XL': {
            'height': [165, 170], 'chest': [99, 106], 'waist': [79, 85],
        }, '2XL': {
            'height': [171, 176], 'chest': [107, 114], 'waist': [86, 94],
        },

    }, apparelTopSize: {
        '2XS/S': {
            'height': [160, 170],
            'chest': [80, 84],
            'waist': [68, 72],
            'hips': [82, 86],
            'inside_arm': [58, 62],
            'inside_leg': [78, 78],
        }, 'XS/S': {
            'height': [160, 170],
            'chest': [85, 88],
            'waist': [73, 76],
            'hips': [87, 90],
            'inside_arm': [58, 60],
            'inside_leg': [81, 81],
        }, 'S': {
            'height': [160, 170],
            'chest': [89, 94],
            'waist': [77, 80],
            'hips': [91, 94],
            'inside_arm': [58, 58],
            'inside_leg': [78, 78],
        }, 'S/L': {
            'height': [182, 194],
            'chest': [89, 94],
            'waist': [77, 80],
            'hips': [91, 94],
            'inside_arm': [66, 70],
            'inside_leg': [85, 85],
        }, 'M/S': {
            'height': [160, 170],
            'chest': [95, 102],
            'waist': [81, 88],
            'hips': [95, 102],
            'inside_arm': [58, 62],
            'inside_leg': [77, 77],
        }, 'M/L': {
            'height': [182, 194],
            'chest': [95, 102],
            'waist': [81, 88],
            'hips': [95, 102],
            'inside_arm': [66, 70],
            'inside_leg': [87, 87],
        }, 'L/S': {
            'height': [160, 170],
            'chest': [103, 110],
            'waist': [89, 96],
            'hips': [103, 110],
            'inside_arm': [60, 64],
            'inside_leg': [87, 87],
        }, 'L': {
            'height': [182, 194],
            'chest': [103, 110],
            'waist': [89, 96],
            'hips': [103, 110],
            'inside_arm': [68, 72],
            'inside_leg': [89, 89],
        }, 'XL/S': {
            'height': [160, 170],
            'chest': [111, 118],
            'waist': [97, 104],
            'hips': [111, 118],
            'inside_arm': [60, 64],
            'inside_leg': [79, 79],
        }, 'XL/L': {
            'height': [182, 194],
            'chest': [111, 118],
            'waist': [97, 104],
            'hips': [111, 118],
            'inside_arm': [68, 72],
            'inside_leg': [88, 88],
        }, '2XL/S': {
            'height': [160, 170],
            'chest': [119, 125],
            'waist': [105, 112],
            'hips': [119, 126],
            'inside_arm': [60, 64],
            'inside_leg': [77, 77],
        }, '2XL/L': {
            'height': [182, 194],
            'chest': [119, 125],
            'waist': [105, 112],
            'hips': [119, 126],
            'inside_arm': [68, 72],
            'inside_leg': [87, 87],
        }, '3XL/L': {
            'height': [182, 194],
            'chest': [126, 134],
            'waist': [113, 120],
            'hips': [127, 134],
            'inside_arm': [66, 70],
            'inside_leg': [84, 84],
        },
    }, femaleApparelTopSize: {
        '2XS/S': {
            'height': [158, 167],
            'chest': [79, 82],
            'waist': [58, 61],
            'hips': [83, 86],
            'inside_arm': [55, 58],
            'inside_leg': [79, 79],
        }, 'XS/S': {
            'height': [158, 167],
            'chest': [83, 86],
            'waist': [62, 65],
            'hips': [90, 91],
            'inside_arm': [58, 60],
            'inside_leg': [81, 81],
        }, 'S': {
            'height': [158, 167],
            'chest': [87, 90],
            'waist': [66, 69],
            'hips': [91, 94],
            'inside_arm': [55, 58],
            'inside_leg': [78, 78],
        }, 'S/L': {
            'height': [177, 180],
            'chest': [87, 90],
            'waist': [66, 69],
            'hips': [91, 94],
            'inside_arm': [60, 62],
            'inside_leg': [85, 85],
        }, 'M/S': {
            'height': [158, 167],
            'chest': [91, 94],
            'waist': [70, 73],
            'hips': [95, 98],
            'inside_arm': [55, 58],
            'inside_leg': [80, 80],
        }, 'M/L': {
            'height': [177, 180],
            'chest': [91, 94],
            'waist': [70, 73],
            'hips': [95, 98],
            'inside_arm': [62, 66],
            'inside_leg': [87, 87],
        }, 'L/S': {
            'height': [158, 167],
            'chest': [95, 98],
            'waist': [74, 77],
            'hips': [99, 102],
            'inside_arm': [55, 58],
            'inside_leg': [79, 79],
        }, 'L': {
            'height': [177, 180],
            'chest': [95, 98],
            'waist': [74, 77],
            'hips': [99, 102],
            'inside_arm': [62, 66],
            'inside_leg': [87, 87],
        }, 'XL/S': {
            'height': [158, 167],
            'chest': [99, 102],
            'waist': [78, 81],
            'hips': [103, 106],
            'inside_arm': [59, 62],
            'inside_leg': [81, 81],
        }, 'XL/L': {
            'height': [177, 180],
            'chest': [99, 102],
            'waist': [78, 81],
            'hips': [103, 106],
            'inside_arm': [65, 67],
            'inside_leg': [86, 86],
        },
    }, plateSize: {

        'S1': {
            'chest': [84, 94], 'waist': [72, 82]
        }, 'M1': {
            'chest': [95, 110], 'waist': [72, 82]
        }, 'M2': {
            'chest': [84, 110], 'waist': [83, 98]
        }, "L1": {
            'chest': [84, 118], 'waist': [99, 106]
        }, "L2": {
            'chest': [111, 118], 'waist': [72, 98]
        }, "XL1": {
            'chest': [84, 134], 'waist': [107, 122]
        }, "XL2": {
            'chest': [119, 134], 'waist': [72, 106]
        },

    },
    ballisticBriefcaseSize: {
        'M': {
            'height': [46, 53], 'width': [66, 76],

        }, 'L': {
            'height': [46, 53], 'width': [66, 76],
        },
    }
}
export {table}